/* Hundben Black Month 2026: gåva i varukorgen (2026-10-22, snabbare 2026-10-26, "Vill ej ha" utan orderrad 2026-11-02)
   - Finns minst en vanlig vara i varukorgen läggs gåvan till med en slumpad sort som finns i lager (viktad efter lagersaldo, 2026-10-26).
   - Gåvan har alltid antal 1 och finns bara en gång.
   - Töms varukorgen på vanliga varor tas gåvan bort. Bara varor som skickas räknas (inte digitala presentkort), 2026-10-26.
   - Kunden byter sort i rullistan på gåvoraden. Väljer kunden "Vill ej ha" tas gåvoraden bort och valet sparas som
     varukorgsattributet "Black Month-gåva: Vill ej ha" (syns på ordern men blir ingen plockrad). Knappen
     "Jag vill ha gåvan ändå" tar bort attributet och lägger tillbaka gåvan (2026-11-02).
   - Snabbväg: när temat har lagt till en vara och vi vet att gåvan saknas läggs gåvan till direkt,
     och den uppdaterade varukorgen hämtas i samma anrop. Gåvoprodukten hämtas när sidan laddas.
   Gåvan känns igen på produkttypen "Gåva". */
(function () {
  var HANDLE = 'black-month-gava-dr-clauders-godis';
  var GIFT_TYPE = 'Gåva';
  var PROP = { _bm_gift: '2026' };
  var NO_GIFT = 'Vill ej ha';
  var ATTR = 'Black Month-gåva';
  var DELAY = 50;
  var origFetch = window.fetch.bind(window);
  var busy = false;
  var again = false;
  var againFast = false;
  var timer = null;
  var pendingFast = false;
  var giftProduct = null;
  var productPromise = null;
  var hasGift = null; // null = vet inte, annars true/false enligt senast lästa varukorg
  var optOut = null;  // null = vet inte, annars true om kunden valt bort gåvan

  function json(url, body) {
    var opt = { headers: { Accept: 'application/json', 'X-HB-Gift': '1' } };
    if (body) {
      opt.method = 'POST';
      opt.headers['Content-Type'] = 'application/json';
      opt.body = JSON.stringify(body);
    }
    return origFetch(url, opt).then(function (r) { return r.json(); });
  }

  function loadProduct() {
    if (giftProduct) return Promise.resolve(giftProduct);
    if (productPromise) return productPromise;
    productPromise = origFetch('/products/' + HANDLE + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (p) { giftProduct = p; productPromise = null; return p; })
      .catch(function () { productPromise = null; return null; });
    return productPromise;
  }

  function availableVariants(p) {
    return (p && p.variants ? p.variants : []).filter(function (v) { return v.available && v.title !== NO_GIFT; });
  }

  // Slumpa sort viktat efter lagersaldo (window.HB_GIFT_STOCK från temat), så att sorterna tar slut ungefär samtidigt.
  // Saknas saldot för en sort räknas den med vikt 1.
  function pickWeighted(vs) {
    var stock = window.HB_GIFT_STOCK || {};
    var weights = vs.map(function (v) { var q = Number(stock[v.id]); return q > 0 ? q : 1; });
    var total = weights.reduce(function (a, b) { return a + b; }, 0);
    var r = Math.random() * total;
    for (var i = 0; i < vs.length; i++) { r -= weights[i]; if (r < 0) return vs[i]; }
    return vs[vs.length - 1];
  }

  function isGift(item) { return item.product_type === GIFT_TYPE; }
  function readOptOut(cart) { return !!(cart && cart.attributes && cart.attributes[ATTR] === NO_GIFT); }

  function sectionIds() {
    var s = [];
    document.documentElement.dispatchEvent(new CustomEvent('cart:grouped-sections', { bubbles: true, detail: { sections: s } }));
    return s;
  }

  function publish(cart, sections) {
    if (!window.FoxTheme || !FoxTheme.pubsub || !sections) return;
    cart.sections = sections;
    FoxTheme.pubsub.publish(FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate, { cart: cart });
  }

  function refreshUI() {
    var ids = sectionIds();
    if (!ids.length) return json('/cart.js').then(function (c) { hasGift = c.items.some(isGift); optOut = readOptOut(c); });
    return Promise.all([
      json('/cart.js'),
      origFetch('/?sections=' + ids.join(','), { headers: { 'X-HB-Gift': '1' } }).then(function (r) { return r.json(); })
    ]).then(function (res) {
      hasGift = res[0].items.some(isGift);
      optOut = readOptOut(res[0]);
      publish(res[0], res[1]);
    });
  }

  // Lägger till gåvan och hämtar varukorgens sektioner i samma anrop.
  function addGift() {
    if (optOut) return Promise.resolve(null);
    return loadProduct().then(function (p) {
      var vs = availableVariants(p);
      if (!vs.length) return null;
      var v = pickWeighted(vs);
      var ids = sectionIds();
      var body = { items: [{ id: v.id, quantity: 1, properties: PROP }] };
      if (ids.length) body.sections = ids.join(',');
      return json('/cart/add.js', body).then(function (res) {
        if (!res || res.status) return refreshUI(); // fel, läs om varukorgen
        hasGift = true;
        return json('/cart.js').then(function (cart) {
          hasGift = cart.items.some(isGift);
          optOut = readOptOut(cart);
          publish(cart, res.sections);
        });
      });
    });
  }

  function syncFull() {
    var changed = false;
    return json('/cart.js')
      .then(function (cart) {
        var gifts = cart.items.filter(isGift);
        var others = cart.items.filter(function (i) { return !isGift(i) && i.requires_shipping; });
        var updates = {};
        var needUpdate = false;
        var body = null;
        hasGift = gifts.length > 0;
        optOut = readOptOut(cart);

        // Äldre varukorgar kan ha "Vill ej ha" som egen rad: gör om den till attributet.
        if (gifts.some(function (g) { return g.variant_title === NO_GIFT; })) {
          gifts.forEach(function (g) { updates[g.key] = 0; });
          body = { updates: updates, attributes: {} };
          body.attributes[ATTR] = NO_GIFT;
          changed = true;
          return json('/cart/update.js', body);
        }
        if (!others.length || optOut) {
          gifts.forEach(function (g) { updates[g.key] = 0; needUpdate = true; });
          if (needUpdate) { changed = true; return json('/cart/update.js', { updates: updates }); }
          return null;
        }
        if (gifts.length) {
          gifts.forEach(function (g, i) {
            if (i > 0) { updates[g.key] = 0; needUpdate = true; }
            else if (g.quantity !== 1) { updates[g.key] = 1; needUpdate = true; }
          });
          if (needUpdate) { changed = true; return json('/cart/update.js', { updates: updates }); }
          return null;
        }
        return addGift().then(function () { return 'done'; });
      })
      .then(function (r) { if (changed && r !== 'done') return refreshUI(); });
  }

  function sync() {
    var fast = pendingFast;
    pendingFast = false;
    if (busy) { again = true; againFast = againFast || fast; return; }
    busy = true;
    // Snabbväg: temat har just lagt till en vara och varukorgen saknade gåvan (och kunden har inte valt bort den).
    var job = (fast && hasGift === false && optOut === false) ? addGift() : syncFull();
    job
      .catch(function (e) { console.warn('HB gåva:', e); hasGift = null; })
      .then(function () {
        busy = false;
        if (again) { again = false; pendingFast = againFast; againFast = false; schedule(pendingFast); }
      });
  }

  function schedule(fast) {
    if (fast) pendingFast = true;
    clearTimeout(timer);
    timer = setTimeout(sync, DELAY);
  }

  function changeSort(select) {
    var key = select.getAttribute('data-key');
    var id = Number(select.value);
    var opt = select.options[select.selectedIndex];
    var none = !!(opt && opt.text.trim() === NO_GIFT);
    var row = select.closest('.cart-item');
    if (row) row.classList.add('hb-gift--busy');
    busy = true;
    var u = {}; u[key] = 0;
    var job;
    if (none) {
      var body = { updates: u, attributes: {} };
      body.attributes[ATTR] = NO_GIFT;
      job = json('/cart/update.js', body).then(function () { optOut = true; hasGift = false; });
    } else {
      job = json('/cart/update.js', { updates: u })
        .then(function () { return json('/cart/add.js', { items: [{ id: id, quantity: 1, properties: PROP }] }); });
    }
    job
      .then(refreshUI)
      .catch(function (e) { console.warn('HB gåva:', e); })
      .then(function () { busy = false; schedule(false); });
  }

  // "Jag vill ha gåvan ändå": ta bort valet och låt synken lägga tillbaka gåvan.
  function undoOptOut(btn) {
    btn.disabled = true;
    busy = true;
    var body = { attributes: {} };
    body.attributes[ATTR] = '';
    json('/cart/update.js', body)
      .then(function () { optOut = false; })
      .catch(function (e) { console.warn('HB gåva:', e); })
      .then(function () { busy = false; schedule(false); });
  }

  // Sortväljaren: fånga ändringen före temats varukorg, som annars tolkar den som en antalsändring.
  document.addEventListener('change', function (e) {
    var t = e.target;
    if (t && t.classList && t.classList.contains('hb-gift-select')) {
      e.stopPropagation();
      changeSort(t);
    }
  }, true);
  document.addEventListener('click', function (e) {
    var b = e.target && e.target.closest && e.target.closest('.hb-gift-undo');
    if (b) { e.preventDefault(); e.stopPropagation(); undoOptOut(b); }
  }, true);

  // Snabbvägen används bara när temat lade till minst en vara som skickas (inte ett digitalt presentkort).
  function shippable(data) {
    var items = data && (data.items || (data.id ? [data] : null));
    return !!(items && items.some(function (i) { return i.requires_shipping; }));
  }

  function onCartCall(url, ok, data) {
    if (/\/cart\/clear/.test(url)) hasGift = false;
    schedule(ok && /\/cart\/add/.test(url) && shippable(data));
  }

  // Lyssna på varukorgsändringar som görs av temat och appar.
  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var own = init && init.headers && (init.headers['X-HB-Gift'] || (init.headers.get && init.headers.get('X-HB-Gift')));
    var p = origFetch(input, init);
    if (!own && /\/cart\/(add|change|update|clear)/.test(url)) {
      p.then(function (r) {
        if (!r || !r.ok || !/\/cart\/add/.test(url)) { onCartCall(url, r && r.ok, null); return; }
        r.clone().json().then(function (d) { onCartCall(url, true, d); }, function () { onCartCall(url, true, null); });
      }, function () { schedule(false); });
    }
    return p;
  };
  var xOpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (method, url) {
    var u = String(url);
    if (/\/cart\/(add|change|update|clear)/.test(u)) {
      this.addEventListener('load', function () {
        var d = null;
        try { d = JSON.parse(this.responseText); } catch (e) {}
        onCartCall(u, this.status >= 200 && this.status < 300, d);
      });
    }
    return xOpen.apply(this, arguments);
  };
  document.addEventListener('cart:updated', function () { schedule(false); });

  function start() { loadProduct(); schedule(false); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
